<template>
  <div class="google-map" ref="map"></div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      zoom: {
        type: Number,
        required: false,
        default: 11
      }
    },
    data() {
      return {
        map: undefined,
        marker: undefined,
        unsubscribe: undefined
      }
    },
    computed: {
      ...mapGetters(['lat', 'lng'])
    },
    mounted() {
      const that = this
      // Create map
      const options = {
        zoom: this.zoom,
        center: new window.google.maps.LatLng(this.lat, this.lng) //Glendale, CA
      }
      this.map = new window.google.maps.Map(this.$refs.map, options)
      // Add event listener for clicks
      window.google.maps.event.addListener(this.map, 'click', function(event) {
        that.$store.dispatch('updateAuctionCoordinates', {
          'lat': event.latLng.lat(),
          'lng': event.latLng.lng()
        })
      })
      this.unsubscribe = this.$store.subscribe(mutation => {
        if (mutation.type === 'auctionCoordinates' || mutation.type === 'setDataToNewAuctionStorage') {
          that.placeMarker()
        }
      })
      that.placeMarker()
    },
    destroyed() {
      this.unsubscribe()
    },
    methods: {
      placeMarker() {
        // Remove (possible) old marker
        if (this.marker) {
          this.marker.setMap(null)
        }
        // Read new value from store
        this.marker = new window.google.maps.Marker({
          position: {
            'lat': this.lat,
            'lng': this.lng
          },
          map: this.map
        })
        // Re-center the map
        this.map.panTo(this.marker.getPosition())
      },
    }
  }
</script>

<style scoped>
  .google-map {
    width: 100%;
    height: 15rem;
    background-color: #f0f0f0;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/Map.vue